// extracted by mini-css-extract-plugin
export default {"Next":"FooterPopup_Next__4jWFZ","Footer":"FooterPopup_Footer__H3ZQf","Cancel":"FooterPopup_Cancel__3sd9H","SecondaryRow":"FooterPopup_SecondaryRow__xTXyn"};